import { useEffect } from 'react';

const SEO = ({ 
  title, 
  description, 
  canonical,
  type = 'website',
  image,
  noindex = false,
  breadcrumbs = [],
  customSchema = null
}) => {
  const siteName = 'Atlantique Spa Boutique';
  const baseUrl = 'https://atlantiquespaboutique.com';
  const defaultDescription = 'Vente de spas par un technicien spécialiste à Nantes et Grand Ouest (44, 85, 56, 49). Sélection rigoureuse, installation maîtrisée, suivi durable.';
  
  const fullTitle = title ? String(title) : siteName + ' | Spécialiste Spa Nantes et Grand Ouest';
  const desc = description ? String(description) : defaultDescription;
  const url = canonical ? baseUrl + String(canonical) : baseUrl;

  useEffect(() => {
    // Set document title
    document.title = fullTitle;

    // Update meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', desc);
    }

    // Update canonical
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (link) {
        link.setAttribute('href', url);
      }
    }

    // Update OG tags
    const updateMeta = (property, content) => {
      let meta = document.querySelector(`meta[property="${property}"]`);
      if (meta) {
        meta.setAttribute('content', content);
      }
    };

    updateMeta('og:title', fullTitle);
    updateMeta('og:description', desc);
    updateMeta('og:url', url);
    updateMeta('og:type', type);
    if (image) {
      updateMeta('og:image', String(image));
    }

    // Update Twitter tags
    const updateTwitterMeta = (name, content) => {
      let meta = document.querySelector(`meta[property="twitter:${name}"]`);
      if (meta) {
        meta.setAttribute('content', content);
      }
    };

    updateTwitterMeta('title', fullTitle);
    updateTwitterMeta('description', desc);
    if (image) {
      updateTwitterMeta('image', String(image));
    }

    // Remove old JSON-LD scripts
    const oldScripts = document.querySelectorAll('script[data-seo-schema]');
    oldScripts.forEach(script => script.remove());

    // Add breadcrumb schema
    if (breadcrumbs && breadcrumbs.length > 0) {
      const breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": breadcrumbs.map((item, index) => ({
          "@type": "ListItem",
          "position": index + 1,
          "name": item.name,
          "item": baseUrl + item.url
        }))
      };
      
      const breadcrumbScript = document.createElement('script');
      breadcrumbScript.type = 'application/ld+json';
      breadcrumbScript.setAttribute('data-seo-schema', 'breadcrumb');
      breadcrumbScript.textContent = JSON.stringify(breadcrumbSchema);
      document.head.appendChild(breadcrumbScript);
    }

    // Add custom schema (e.g., Product)
    if (customSchema) {
      const customScript = document.createElement('script');
      customScript.type = 'application/ld+json';
      customScript.setAttribute('data-seo-schema', 'custom');
      customScript.textContent = JSON.stringify(customSchema);
      document.head.appendChild(customScript);
    }

    // Cleanup
    return () => {
      const scripts = document.querySelectorAll('script[data-seo-schema]');
      scripts.forEach(script => script.remove());
    };

  }, [fullTitle, desc, url, canonical, type, image, breadcrumbs, customSchema]);

  return null;
};

export default SEO;
